import React from 'react'
import PropTypes from 'prop-types'
import { IconPDLSparkle } from '@edulastic/icons'
import {
  StyledAIAssistanceContainer,
  StyledHeaderSection,
  StyledMetadataTitle,
  StyledScrollableContent,
  StyledWrapper,
} from './styled'
import QuestionMetadataSection from './QuestionMetadataSection'

const AIAssistance = ({ onSaveSuggestedMetadata }) => {
  return (
    <StyledWrapper data-cy="pearAssistPanel">
      <StyledAIAssistanceContainer>
        <StyledHeaderSection>
          <IconPDLSparkle width="24px" height="24px" />
          <StyledMetadataTitle data-cy="pearAssistTitle">
            Pear Assist
          </StyledMetadataTitle>
        </StyledHeaderSection>
        <StyledScrollableContent>
          <QuestionMetadataSection
            onSaveSuggestedMetadata={onSaveSuggestedMetadata}
          />
        </StyledScrollableContent>
      </StyledAIAssistanceContainer>
    </StyledWrapper>
  )
}

AIAssistance.propTypes = {
  onSaveSuggestedMetadata: PropTypes.func,
}

AIAssistance.defaultProps = {
  onSaveSuggestedMetadata: () => {},
}

export default AIAssistance
